var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('v-btn',{attrs:{"color":"primary text--secondary","block":_vm.block},on:{"click":function($event){return _vm.open()}}},[_vm._v(" "+_vm._s(_vm.$t('ps.general.menu.sign-up'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }